export default "__VITE_ASSET__Cf2M3M5a__"